import User from '../../model/User'

const UserList: User[] = [
  {username: '160296', name: 'User #1', location: 'Tirunelveli', points: 10000, mobileNumber: '9789908986'}
]

export default UserList
